














import Vue from 'vue'
import ABarchart from './ABarchart.vue'
import ATable from './ATable.vue'
import AInfoCard from './AInfoCard.vue'
import {mapState, mapGetters, mapActions} from 'vuex'

// const dataStore = new CustomStore({
//   key: 'HGNC_symbol',
//   loadMode: 'raw',
//   load: async() => (await fetch('annotation.json')).json(),
// })

// const dataSource = new DataSource({
//   store: dataStore,
//   map: (elem) => {
//     elem._selected = true
//     return elem
//   }
// })

export default Vue.extend({
  components: { ABarchart, ATable, AInfoCard },
  data() {
    return {
      // families: ['SLC1','SLC2','SLC3'],
      // subcellularLocalizations: ['ER','Golgi','Mitochondria','Unknown', 'Plasma membrane', 'Lysosome', 'Vesicles', 'Cytoplasm'],
      // substratesFilter: [{text: 'family 1 & 2', value: [['family', '=', 'SLC1'], 'or', ['family', '=', 'SLC2']]}, {text: 'Metal & Ion', value: [['Substrate_class', '=', 'Ion'], 'or', ['Substrate_class', '=', 'Metal']]}, {text: 'Metal', value: 'Metal'}, {text: 'Ion', value: ['Substrate_class', '=', 'Ion']}],
      showRelativeFamily: false,
      showRelativeSubstrateClass: false,
      // store: new CustomStore({
      //     key: 'HGNC_symbol',
      //     load: (loadOptions) => {
      //       console.log(loadOptions)
      //     }
      // }),
      // dataStore,
      // dataSource,
      // subcellularHeaderFilter: [
      //   {text: 'ER', value: [['Subcellular_localization', 'contains', 'ER']]},
      //   {text: 'Golgi', value: [['Subcellular_localization', 'contains', 'Golgi']]},
      //   {text: 'Mitochondria', value: [['Subcellular_localization', 'contains', 'Mitochondria']]},
      //   {text: 'Lysosome', value: [['Subcellular_localization', 'contains', 'Lysosome']]},
      //   {text: 'custom', value: [['Subcellular_localization', 'contains', 'Golgi'], 'and', ['Subcellular_localization', 'contains', 'ER']] }
      // ]
      columns: [
        {dataField: 'HGNC_symbol', caption: 'gene symbol'},
        {dataField: 'family', caption: 'SLC family'},
        {dataField: 'Substrates_chebi_label', caption: 'substrates (ontology)'},
        {dataField: 'Substrate_class', caption: 'substrate class'},
        {dataField: 'Coupled_ions', caption: 'coupled ions'},
        {dataField: 'Transport_system', caption: 'transport system'},
        {dataField: 'Subcellular_localization', caption: 'subcellular localization'},
      ]
    }
  },
  mounted() {
    this.loadData({url: 'annotation.json', keyField: 'HGNC_symbol'})
    if (this.$route.params.filter) {
        console.log('setting filter based on URL:')
        console.log(JSON.parse(this.$route.params.filter))
        this.setFilter({filter: JSON.parse(this.$route.params.filter), updateRouter: false})
    }
  },
  computed: {
    ...mapState(['count', 'entries', 'focusedEntry']),
    ...mapGetters(['entriesCount'])
  },
  methods: {
    ...mapActions(['loadData','selectEntries','setFilter']),
    // handle select events
    // select(selectedIndices: number[]) {
      // if (selectedIndices) {
      //   this.selectedIndices = selectedIndices
      // } else {
      //   this.selectedIndices = seq(this.rowData.length)
      // }
      // this.rowData.forEach(elem => elem.set('_selected', '0'))
      // this.selectedIndices.forEach(i => this.rowData[i].set('_selected', '1'))

      //this.grid.api.getFilterInstance('_selected').setModel({type: 'equals', filter: '1'})
      //this.grid.api.onFilterChanged()
      //Plotly.restyle(this.$refs.plot, {selectedpoints: [this.selectedIndices]}) // needs an array of arrays
      //Plotly.restyle(this.$refs.plot, this.plotData())
    // },

    // load and process the table
    //async fetchData() {
      // // read in the data
      // var tsv = await (await fetch('../TabS1_Annotation.tsv')).text()
      // this.loadAnnotation()
      
      //this.rowData = tsv2objects(tsv)
      //this.rowData.forEach(elem => elem._selected = 0)
    //},
    tooltip(pointInfo: {argumentText: string; points: [{valueText: string}, {valueText: string}]; totalText: string}) {
      //console.log(pointInfo)
      return { text: `<strong>${pointInfo.argumentText}:</strong> selected <strong>${pointInfo.points[1].valueText}</strong> out of <strong>${pointInfo.totalText}</strong> SLCs` }
    },
    pointClickFamily(e: any) {
      this.setFieldFilter(e.target.series.getArgumentField(), e.target.argument)
      //this.$refs.plotByFamily.instance.refresh()
    },
    pointClickSubstrateClass(e: any) {
      console.log('click', Date.now())
      this.setFieldFilter(e.target.series.getArgumentField(), e.target.argument)
      //this.$refs.plotByFamily.instance.refresh()
    },
    setFieldFilter(fieldName: string, fieldValue: string) {
      console.log('setting filter on table...', Date.now());
      (this.$refs.table as any).instance.clearFilter();
      (this.$refs.table as any).instance.columnOption(fieldName, 'filterValues', [fieldValue]);
      
      console.log('setting filter on table done', Date.now());
      this.selectEntries({fieldName, fieldValue})
    },
    selectedSeries(selectedState: any) {
      if (selectedState) {
        return { color: '#856fbb', name: 'selected' }
      } else {
        return { color: '#f8ebff', name: 'unselected' }
      }
    },
    drawn() {
      console.log('plotBySubstrateClass drawn', Date.now())
    },
    
  },
  watch: {
      $route(to, from) {
          console.log(from)
          console.log(to)
      }
  }
})
